/*
 * 系统管理接口
 * */
import services from "../config/axios";
import base from "./base";
// 定义参数类型
type paramsType<T> = {
    [key: string]: T;
};

const systemManageAPI = {
    // 更新用户头像
    updateUserPortrait<T>(params: FormData) {
        return services.post(`${base.lk}/System/UpdateUserPortrait`, params);
    },
    // 获取人员列表
    getUserList<T>(params: FormData) {
        return services.post(`${base.lk}/Account/GetUserList`, params);
    },
    //新增用户
    addUser<T>(params: FormData) {
        return services.post(`${base.lk}/Account/AddUser`, params);
    },
    //删除用户
    delUser<T>(params: FormData) {
        return services.post(`${base.lk}/Account/DelUser`, params);
    },
    //修改用户密码
    changeUserPwd<T>(params: FormData) {
        return services.post(`${base.lk}/Account/ChangeUserPassword`, params);
    },
    //编辑用户
    updateUser<T>(params: FormData) {
        return services.post(`${base.lk}/Account/UpdateUser`, params);
    },
    //获取一个用户
    getUserOne<T>(params: FormData) {
        return services.post(`${base.lk}/Account/GetUserOne`, params);
    },
    //获取操作日志
    getSysLogsList<T>(params: FormData) {
        return services.post(`${base.lk}/Account/GetSysLogsList`, params);
    },
    //获取公告列表
    getBulletinList<T>(params: FormData) {
        return services.post(`${base.lk}/Account/GetBulletinList`, params);
    },
    //新增公告
    addBulletin<T>(params: FormData) {
        return services.post(`${base.lk}/Account/AddBulletin`, params);
    },
    //获取公告
    getBulletinOne<T>(params: FormData) {
        return services.post(`${base.lk}/Account/GetBulletinOne`, params);
    },
    //更新公告
    updateBulletin<T>(params: FormData) {
        return services.post(`${base.lk}/Account/UpdateBulletin`, params);
    },
    deleteBulletin<T>(params: FormData) {
        return services.post(`${base.lk}/Account/DeleteBulletin`, params);
    },
    getAppMessageList<T>(params: object) {
        return services.get(`${base.lk}/admin/app-messages`, { params });
    },
    getAppMessageOne<T>(id: number) {
        return services.get(`${base.lk}/admin/app-messages/${id}`);
    },
    createAppMessage<T>(params: object) {
        return services.post(`${base.lk}/admin/app-messages`, params, { headers: { "Content-Type": "application/json" } });
    },
    updateAppMessage<T>(id: number, params: object) {
        return services.post(`${base.lk}/admin/app-messages/${id}/update`, params, { headers: { "Content-Type": "application/json" } });
    },
    publishAppMessage<T>(id: number) {
        return services.post(`${base.lk}/admin/app-messages/${id}/publish`);
    },
    offlineAppMessage<T>(id: number) {
        return services.post(`${base.lk}/admin/app-messages/${id}/unpublish`);
    },
    getAppMessageStatistics<T>(id: number) {
        return services.get(`${base.lk}/admin/app-messages/${id}/stats`);
    },
    getAppMessageStatisticDetails<T>(id: number, params: object) {
        return services.get(`${base.lk}/admin/app-messages/${id}/stats/details`, { params });
    },
    //获取感言列表
    getSpeechList<T>(params: FormData) {
        return services.post(`${base.lk}/Account/GetSpeechList`, params);
    },
    //新增感言
    addSpeech<T>(params: FormData) {
        return services.post(`${base.lk}/Account/AddSpeech`, params);
    },
    //获取感言
    getSpeechOne<T>(params: FormData) {
        return services.post(`${base.lk}/Account/GetSpeechOne`, params);
    },
    //更新感言
    updateSpeech<T>(params: FormData) {
        return services.post(`${base.lk}/Account/UpdateSpeech`, params);
    },
    deleteSpeech<T>(params: FormData) {
        return services.post(`${base.lk}/Account/DeleteSpeech`, params);
    },
    //获取共享列表
    getShareList<T>(params: FormData) {
        return services.post(`${base.lk}/System/GetShareList`, params);
    },
    getFPShareList<T>(params: FormData) {
        return services.post(`${base.lk}/System/GetFPShareList`, params);
    },
    //新增共享
    addShare<T>(params: FormData) {
        return services.post(`${base.lk}/System/AddShare`, params);
    },
    //获取公告
    getShareOne<T>(params: FormData) {
        return services.post(`${base.lk}/System/GetShareOne`, params);
    },
    //更新共享
    updateShare<T>(params: FormData) {
        return services.post(`${base.lk}/System/UpdateShare`, params);
    },
    //删除共享
    deleteShare<T>(params: FormData) {
        return services.post(`${base.lk}/System/DeleteShare`, params);
    },
    //修改密码
    updatePassword<T>(params: FormData) {
        return services.post(`${base.lk}/System/UpdatePassword`, params);
    },
    //获取密钥
    getCryptKey<T>(params: FormData) {
        return services.post(`${base.lk}/System/GetCryptKey`, params);
    },
    //获取机器清单
    getMachineList<T>(params: FormData) {
        return services.post(`${base.lk}/System/GetMachineList`);
    },
    //获取派神易机器清单
    getMachineListPsy<T>(params: FormData) {
        return services.post(`${base.lk}/System/GetMachineListPsy`);
    },
    //获取机器清单pctype
    getMachineListByType<T>(params: FormData) {
        return services.post(`${base.lk}/System/GetMachineListByType`, params);
    },
    //生产资产加密密钥
    createCryptKey<T>(params: FormData) {
        return services.post(`${base.lk}/Account/CreateCryptKey`, params);
    },
    //获取LookupValue
    getLookupValue<T>(params: FormData) {
        return services.post(`${base.lk}/Account/GetLookupValue`, params);
    },
    //执行登录后的些操作
    doSomethingAfterLogin<T>(params: FormData) {
        return services.post(
            `${base.lk}/Account/DoSomethingAfterLogin`,
            params
        );
    },
    //获取投票
    getVoteList<T>(params: FormData) {
        return services.post(`${base.lk}/Account/GetVoteList`, params);
    },
    //获取投票流程清单
    getVoteProcessList<T>(params: FormData) {
        return services.post(`${base.lk}/Account/GetVoteProcessList`, params);
    },
    //新增投票
    addVote<T>(params: FormData) {
        return services.post(`${base.lk}/Account/AddVote`, params);
    },
    //获取一个投票
    getVoteOne<T>(params: FormData) {
        return services.post(`${base.lk}/Account/GetVoteOne`, params);
    },
    //更新投票
    updateVote<T>(params: FormData) {
        return services.post(`${base.lk}/Account/UpdateVote`, params);
    },
    deleteVote<T>(params: FormData) {
        return services.post(`${base.lk}/Account/DeleteVote`, params);
    },
    //添加投票清单
    addVoteList<T>(params: FormData) {
        return services.post(`${base.lk}/Account/AddVoteList`, params);
    },
    deleteVoteList<T>(params: FormData) {
        return services.post(`${base.lk}/Account/DeleteVoteList`, params);
    },
    getCertificateList<T>(params: FormData) {
        return services.post(`${base.lk}/Account/GetCertificateList`, params);
    },
    createCertificate<T>(params: FormData) {
        return services.post(`${base.lk}/Account/CreateCertificate`, params);
    },
    delCertificate<T>(params: FormData) {
        return services.post(`${base.lk}/Account/DelCertificate`, params);
    },
    getCertificateOne<T>(params: FormData) {
        return services.post(`${base.lk}/Account/GetCertificateOne`, params);
    },
    updateCertificate<T>(params: FormData) {
        return services.post(`${base.lk}/Account/UpdateCertificate`, params);
    },
    //获取头条列表
    getNewsList<T>(params: FormData) {
        return services.post(`${base.lk}/SystemManage/getNewsList`, params);
    },
    //新增头条
    addNews<T>(params: FormData) {
        return services.post(`${base.lk}/SystemManage/AddNews`, params);
    },
    //获取头条
    getNewsOne<T>(params: FormData) {
        return services.post(`${base.lk}/SystemManage/GetNewsOne`, params);
    },
    //更新头条
    updateNews<T>(params: FormData) {
        return services.post(`${base.lk}/SystemManage/UpdateNews`, params);
    },
    //删除头条
    deleteNews<T>(params: FormData) {
        return services.post(`${base.lk}/SystemManage/DeleteNews`, params);
    },
    //获取公告当天弹窗次数
    getBulletinShowCount<T>(params: FormData) {
        return services.post(`${base.lk}/Account/GetBulletinShowCount`, params);
    },
};

export default systemManageAPI;
